export const AUTH_LAYOUT_LEFT_DRAWER_RIGHT_PADDING = 16;
export const AUTH_LAYOUT_LEFT_DRAWER_OPENED_WIDTH = 230;
export const AUTH_LAYOUT_LEFT_DRAWER_CLOSED_WIDTH = 64;
export const AUTH_LAYOUT_FOOTER_HEIGHT = 54;
